import type { ReactNode } from 'react';
import type { Control, FieldValues, Path } from 'react-hook-form';

import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from '../form';
import { Checkbox } from '../checkbox';
import { Group } from '@folio/components/ui/flex';
import { Text } from '@folio/components/ui/text';

type FormCheckboxInputProps<TFields extends FieldValues> = {
  control: Control<TFields>;
  label?: ReactNode;
  name: Path<TFields>;
  placeholder?: string;
  description?: ReactNode;
  required?: boolean;
  className?: string;
};

export const FormCheckboxInput = <TFields extends FieldValues>({
  control,
  label,
  name,
  description,
  required,
  className,
}: FormCheckboxInputProps<TFields>) => {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className={className}>
          <Group gap={2}>
            <FormControl>
              <Checkbox checked={field.value} onCheckedChange={value => field.onChange(value)} />
            </FormControl>
            {!!label && (
              <FormLabel>
                {label}{' '}
                {required && (
                  <Text inline tone="destructive">
                    *
                  </Text>
                )}
              </FormLabel>
            )}
          </Group>
          {!!description && <FormDescription>{description}</FormDescription>}
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
